import Reveal from '../Reveal'

/**
 * The four facts strip.
 *
 * Deliberately not a "500+ verwaltete Einheiten" block: no such figure exists
 * anywhere in the old site's content, and inventing one on a site that also
 * carries an Impressum would be a claim the operator cannot stand behind. Every
 * number here is traceable - the one-working-day promise, the four-person team,
 * the three mandate types and the § 34c licence.
 */

const STATS = [
  {
    value: '1',
    unit: 'Werktag',
    label: 'Ihr Anliegen ist innerhalb eines Werktages bearbeitet.',
  },
  {
    value: '4',
    unit: 'Köpfe',
    label: 'Ein junges Team, das jedes Objekt persönlich kennt.',
  },
  {
    value: '3',
    unit: 'Bereiche',
    label: 'WEG-, Sondereigentums- und Mietverwaltung aus einer Hand.',
  },
  {
    value: '§ 34c',
    unit: 'GewO',
    label: 'Zugelassene Hausverwalter mit eigener Objekterfahrung.',
  },
]

export default function StatBand() {
  return (
    <section className="section section--tight section--paper">
      <div className="container">
        <Reveal group className="stats">
          {STATS.map((stat) => (
            <div className="stat" key={stat.label}>
              <p className="stat__value">
                {stat.value} <em>{stat.unit}</em>
              </p>
              <p className="stat__label">{stat.label}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  )
}
